import { render, staticRenderFns } from "./WelcomeCard.vue?vue&type=template&id=dd1aea34&scoped=true"
import script from "./WelcomeCard.vue?vue&type=script&lang=js"
export * from "./WelcomeCard.vue?vue&type=script&lang=js"
import style0 from "./WelcomeCard.vue?vue&type=style&index=0&id=dd1aea34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1aea34",
  null
  
)

export default component.exports